import { ProdutoElegibilidade } from './produto-elegibilidade';
import { Cedente } from './cedente';

export class CedenteContrato {
    public valorPadrao: number;
    public cartaoPeriodoPadraoId: number;
    public ehEditavel: boolean;
    public valorMaximoBeneficio: number;
    public valorIncremento: number;
    public taxaPedido: number;
    public ehPorcentagem: boolean;
    public priorizado: boolean;

    public selecionado: boolean;

    constructor(
        public cedenteContratoId: number,
        public situacaoId: number,
        public descricaoSituacao: string,
        public dataCadastro: Date,
        public dataInicioVigencia: Date,
        public dataFimVigencia: Date,
        public produtoElegibilidade: ProdutoElegibilidade,
        public cedente: Cedente
    ) { }

}
